import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
/** Wrapper that creates a scroll-to-me container (Note: adds a div) */
export const ScrollToChildren = ({ children, enabled = true, id, }) => {
    const observedRef = useRef(null);
    const [hasScrolled, setHasScrolled] = useState('');
    // Scroll to the item if its id is requested as scroll target
    useEffect(() => {
        var _a;
        if (id && (observedRef === null || observedRef === void 0 ? void 0 : observedRef.current)) {
            if (enabled && hasScrolled !== id) {
                (_a = observedRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'start',
                });
                setHasScrolled(id);
            }
        }
    }, [enabled, observedRef, id, hasScrolled]);
    return _jsx("div", Object.assign({ ref: observedRef }, { children: children }));
};
